import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, FormControl, InputLabel, MenuItem, Select, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarMunicipio, AgregarMunicipio, Municipios } from "../../connections/catalogos/MunicipioConnection";
import { ObtenerEstados } from "../../connections/catalogos/EstadoConnection";

import { MunicipioProps } from "../../interfaces/catalogos/MunicipioInterface";
import { EstadoProps } from "../../interfaces/catalogos/EstadoInterface";

export const MunicipioPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [MunicipioArray, setMunicipioArray] = useState<MunicipioProps[]>([]);

    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [idMunicipio, setIdMunicipio] = useState(0);
    const [descripcion, setDescripcion] = useState('');

    const [estado, setEstado] = useState(0);
    const [estadoArray, setEstadoArray] = useState<EstadoProps[]>( [] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada: dataFiltrada1 } = useFilter( MunicipioArray, ( item, filtro ) => item.descripcion.toLowerCase().includes( filtro.toLowerCase() ) );
    const { filtro: filtroEstado, setFiltro: setFiltroEstado, dataFiltrada } = useFilter( dataFiltrada1, ( item, filtro ) => (item.estado?.descripcion ?? '').toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const MunicipioSelected = MunicipioArray.find((elem) => elem.idMunicipio === id);

        if (MunicipioSelected) {

            await ActualizarMunicipio({ ...MunicipioSelected, activo: checked }).then(resp => {

                if (resp.idMunicipio) {

                    var newArray = MunicipioArray.map((elem) => {

                        if (elem.idMunicipio === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setMunicipioArray(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 
                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idMunicipio !== 0) {

            const MunicipioSelected = MunicipioArray.find((elem) => elem.idMunicipio === idMunicipio);

            if ( MunicipioSelected ) {

                setLoading(true);

                await ActualizarMunicipio({ ...MunicipioSelected, descripcion, idEstado: estado }).then(resp => {

                    if (resp.idMunicipio) {

                        setTimeout(() => {

                            var newArray = MunicipioArray.map((elem) => {

                                if (elem.idMunicipio === idMunicipio) {
                                    elem.descripcion = descripcion;
                                    elem.idEstado = estado;
                                    elem.estado = resp.estado;
                                }

                                return elem;
                            });

                            setMunicipioArray(newArray);
                            setOpenModal(false);
                            setLoading(false);

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                        }, 700);

                    }

                });
            }


        }
        else {

            const MunicipiosAdd: MunicipioProps = {
                idMunicipio: 0,
                clave: '',
                descripcion,
                activo: true,
                idEstado: estado,
            };

            setLoading(true);

            await AgregarMunicipio(MunicipiosAdd).then(resp => {

                if (resp.idMunicipio) {

                    setTimeout(() => {

                        setMunicipioArray([...MunicipioArray, resp]);
                        setOpenModal(false);
                        setLoading(false);

                        dispatch( openSnackbar({ message: 'Se agregó el municipio correctamente', variant: 'success' })); 

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setMunicipioArray([]);

            await Municipios().then(resp => {

                setTimeout(() => {

                    setMunicipioArray(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerEstados().then( resp => {  
                setEstadoArray( resp );    
            });

        }

        Obtener();

    }, [ ]);

    return (

        <Layout breadcrumbs={[{ text: 'Administración' }, { text: 'Catálogos' }, { text: 'Municipio' }]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    {
                        administrador
                        &&
                            <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={() => {

                            setIdMunicipio( 0 );
                            setEstado( 0 );
                            setDescripcion('');

                            setOpenModal(true);
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar municipio"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtroEstado }
                        label="Buscar por estado"
                        onChange={ ( value ) => {
                            setFiltroEstado( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center'  }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%' }}> Estado </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idMunicipio, descripcion, activo, idEstado, estado }) => (

                                    <TableRow key={idMunicipio} >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center'  }}>
                                            {idMunicipio}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>
                                    
                                        <TableCell>
                                            {estado?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idMunicipio)}
                                            />

                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={() => {

                                                    setIdMunicipio(idMunicipio);
                                                    setEstado( idEstado );
                                                    setDescripcion(descripcion);

                                                    setOpenModal(true);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            (dataFiltrada.length === 0 && !loadingData)
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <CircularProgress size={32} />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={2} sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltrada.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                    colSpan={8}
                                    count={dataFiltrada.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}

                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}

                                    ActionsComponent={TablePaginationActions}

                                    labelRowsPerPage="Filas por página"
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={openModal} maxWidth='sm' fullWidth={true}>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>
                            <FormControl fullWidth>

                                <InputLabel>Estado</InputLabel>

                                <Select
                                    label="Estado"
                                    value={ estado }
                                    onChange={(e) => { setEstado(  e.target.value  ); }}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        estadoArray.map((elem) => (
                                            <MenuItem key={elem.idEstado} value={elem.idEstado}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>
                                
                            </FormControl>
                        </Grid>
             
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField                                
                                label={'Descripción'}
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }} 
                            />
                        </Grid>                        

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={loading} onClick={() => { setOpenModal(false); }}> Cancelar </Button>
                    <Button loading={loading} disabled={descripcion === ''} onClick={handleGuardar} variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}